export enum ChatMessageRole {
  User = 'user',
  Assistant = 'bot',
  System = 'system',
}
export class Message {
  id: string;
  from: ChatMessageRole;
  type: 'text' | 'image';
  text: string;
  links?: Array<{ title: string; url: string }>;
  complete?: boolean;
  isHidden?: boolean;
  partToShow?: string;
  firstEmitIsHere?: boolean;

  constructor(payload: {
    id?: string;
    from?: ChatMessageRole;
    text?: string;
    type: 'text' | 'image';
    isHidden: boolean;
    partToShow?: string;
    complete?: boolean;
  }) {
    this.id = payload.id || Message.generateId();
    this.from = payload.from!;
    this.text = payload.text || '';
    this.type = payload.type || 'text';
    this.isHidden = payload.isHidden || false;
    this.partToShow = payload.partToShow;
    this.complete = payload.complete;
  }

  static generateId(): string {
    const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
    const randomValue = crypto.getRandomValues(new Uint8Array(4)).join('');
    return `${timestamp}-${randomValue}`;
  }
}

export interface Chat {
  id: string;
  deactivated: boolean;
  title: string;
  messages: Message[];
  date: Date;
}
